<template>
  <div id="app">
    <!-- 導航 -->
    <div id="top" class="header">
      <div class="header-container">
        <div class="header-content">
          <!-- logo -->
          <div class="logo">
            <router-link to="/" style="text-decoration: none;">
              <div class="logo-text">派迪軟件</div>
            </router-link>
          </div>

          <!-- 桌面导航 -->
          <div class="nav-links">
            <ul>
              <router-link v-for="(item, index) in tops" :key="index" :to="item.to"  style="text-decoration: none;">
                <li class="nav-item">
                  {{ item.name }}
                </li>
              </router-link>
            </ul>
          </div>

          <!-- 移动端汉堡菜单 -->
          <div class="hamburger" @click="isMenuOpen = !isMenuOpen">
            <div class="hamburger-line" :class="{ 'active': isMenuOpen }"></div>
          </div>
        </div>

        <!-- 移动端下拉菜单 -->
        <transition name="slide">
          <div class="mobile-menu" v-if="isMenuOpen" @click="isMenuOpen = false">
            <router-link v-for="(item, index) in tops" :key="index" :to="item.to" class="mobile-nav-item">
              {{ item.name }}
            </router-link>
          </div>
        </transition>
      </div>
    </div>

    <div :style="topCss" class="hero-container">
      <div class="spacer"></div>
      <div class="content-wrapper">
        <!-- 文字內容 -->
        <div class="text-content" data-aos="fade-right" data-aos-duration="1700">
          <h1 class="main-title">
            <span ref="typed"></span>
          </h1>

          <div class="description">
            智創科技，秉持全棧開發理念，融合前沿技術，為企業定製契合業務發展的優質解決方案。
          </div>

          <div class="contact-tip">
            <p>快來溝通｜期待與您線上交流</p>
          </div>

          <button class="cta-button">
            聯繫我們
          </button>
        </div>
      </div>
    </div>

    <!-- 全宽容器 -->
    <div style="display: block; width: 100%; margin: 0; padding: 0; overflow-x: hidden;">
      <router-view style="
    display: block;
    width: 100%;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  ">
        <!-- 内容容器 -->
        <div style="
      max-width: 1440px;
      margin: 0 auto;
      padding: 20px;
      box-sizing: border-box;
    ">
          <!-- 实际页面内容 -->

        </div>
      </router-view>

    </div>


    <footer role="contentinfo" style="width: 100%; background-color: rgb(30, 30, 30); padding: 80px 0 40px;">
      <div style="max-width: 1200px; margin: 0 auto;">
        <!-- 主内容容器增加 class 便于响应式 -->
        <div class="footer-main-content" style="display: flex; flex-wrap: wrap; gap: 60px; padding: 0 20px;">
          <!-- 品牌信息 -->
          <section class="brand-section" aria-labelledby="company-info" style="flex: 1 1 300px;">
            <h2 id="company-info" style="font-size: 2.5rem; color: #fff; font-weight: 800; margin-bottom: 1.5rem;">
              派迪軟件
            </h2>
            <p style="color: #9e9e9e; line-height: 1.8; max-width: 400px;">
              智創科技，秉持全棧開發理念，融合前沿技術，為企業定製契合業務發展的優質解決方案。
            </p>
          </section>

          <!-- 導航連結 -->
          <nav class="footer-nav"
            style="flex: 2 1 600px; display: flex; gap: min(8%, 120px); justify-content: flex-end;">
            <div v-for="(item, index) in items" :key="index">
              <h3 style="font-size: 1.125rem; color: #fff; margin-bottom: 1.75rem; font-weight: 600;">
                {{ item.table }}
              </h3>
              <ul style="list-style: none; padding: 0; margin: 0;">
                <li v-for="(tem, ind) in item.text" :key="ind" style="margin-bottom: 1rem;">
                  <a :href="tem.to" style="color: #9e9e9e; text-decoration: none; transition: color 0.3s ease;"
                    :aria-label="tem" @mouseover="e => e.target.style.color = '#fff'"
                    @mouseout="e => e.target.style.color = '#9e9e9e'">
                    {{ tem.title }}
                  </a>
                </li>
              </ul>
            </div>
          </nav>
        </div>

        <!-- 版權資訊 -->
        <div class="copyright"
          style="border-top: 1px solid #444; margin-top: 80px; padding-top: 40px; text-align: center;">
          <p style="color: #666; font-size: 0.875rem;">
            © 2025 派迪軟件 版權所有
          </p>
        </div>
      </div>
    </footer>







  </div>
</template>

<script>
import VueScrollTo from 'vue-scrollto';
import AOS from 'aos';
import 'aos/dist/aos.css'
import Typed from 'typed.js';


export default {
  name: 'App',
  data() {
    return {
      isMenuOpen: false,
      topCss: {
        backgroundImage: "url(" + require("@/assets/index-top.png") + ")",
        display: "flex",
        "justify-content": "center",
        "align-items": "center",
        "background-size": "100%"
      },
      items: [
        {
          table: "推薦文章",
          text: [
            {
              title: "新聞動態",
              to: "/NewsPage",
            }, {
              title: "產品案例",
              to: "/ProductExamples",
            },
          ]
        },
        {
          table: "快捷導航",
          text: [
            {
              title: "合作夥伴",
              to: "/Partners",
            },
            {
              title: "聯絡方式",
              to: "/Contact",
            },
            {
              title: "常見問題",
              to: "/Issue",
            },
            {
              title: "關於我們",
              to: "/Concerning",
            },
          ]
        },
        {
          table: "政策&協議",
          text: [
            {
              title: "私隱協議",
              to: "/Privacy",
            },
            {
              title: "服務政策",
              to: "/Serve",
            },
          ]
        }
      ],
      tops: []
    }
  },

  mounted() {
    AOS.init();

    // window.addEventListener('scroll', function () {
    //   const element = document.getElementById('top');
    //   element.style.background = `rgba(255, 107, 107, ${window.scrollY / 100})`
    // });

    new Typed(this.$refs.typed, {
      strings: ["全棧定製", "開發領航"],
      typeSpeed: 100,
      backSpeed: 50,
      backDelay: 2000,
      loop: true,
    });

    this.GetMenuList()
  },
  methods: {
    scrollToSection(sectionId) {
      VueScrollTo.scrollTo(`#${sectionId}`, 500);
    },

    //获取导航栏列表
    GetMenuList() {
      this.$axios.get(`/menu/list?page=1&perPage=10000`)
        .then(res => {
          for (let index = res.data.data.items.length - 1; index >= 0; index--) {
            var data = {
              name: res.data.data.items[index].nick,
              to: res.data.data.items[index].path
            };
            this.tops.push(data);
          }

          console.log(this.tops)
        })
        .catch(e => {
          console.log(e)
        })
    },

  }
}
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
}


.linkButton:hover {
  background-color: white;
  color: black !important;
}

.nav:hover {
  background-color: #fff;
  color: black !important;
}

#ullis ul li {
  /* border: 1px black solid; */
  display: inline-block;
  /* margin: 0 20px 0 20px; */
  font-size: 14px;
  color: white;
}

#uilisSystem ul li {
  display: inline-block;
  font-size: 16px;
  text-align: center;
  /* margin: 0 10px; */
  border-right: 1px rgba(0, 0, 0, 0.1) solid;
  padding: 0 85px;
  line-height: 70px;
  color: rgba(0, 0, 0, 0.5);
}

#uilisSystem ul li img {
  width: 20px;
  height: 20px;
  margin-right: 6px;
}

#card ul li {
  width: 230px;
  height: 240px;
  display: inline-block;
  margin: 16px 30px;
  border-radius: 20px;
  vertical-align: top;
  padding: 40px 20px;
}

#card ul li img {
  width: 203px;
  height: 130px;
}

#card ul li div {
  font-size: 22px;
  margin-top: 40px;
  color: white;
  font-weight: bold;
  text-align: left;
}

#ullisLeft div {
  font-size: 40px;
  /* border: 1px red solid; */
}

#uilisList ul li {
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  font-size: 55px;
  margin: 40px 0;
  font-weight: bold;
}

#uilisList ul li img {
  width: 80px;
  height: 80px;
  margin-left: 20px;
}

#ulliLists ul li {
  list-style: none;
  width: 380px;
  height: 370px;
  display: inline-block;
  margin: 30px;
  border-radius: 12px;
  vertical-align: top;
  background-color: rgb(255, 255, 255);
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
}

.gradient-text {
  /* 設置漸變背景（線性漸變） */
  background: linear-gradient(45deg, #ff6b6b, #4ecdc4, #45b7d1);
  -webkit-background-clip: text;
  /* 關鍵：將背景裁剪到文字 */
  background-clip: text;
  color: transparent;
  /* 隱藏原文字顏色，顯示漸變背景 */
  font-size: 48px;
  font-weight: bold;
  /* display: inline-block; */
}

#ullisLogo ul li {
  /* display: inline-block; */
  /* width: 50px; */
  /* height: 50%; */
  margin: 0 20px;
  list-style: none;
}

#ullisLogo ul li img {
  width: 50px;
  height: 50px;
}

#ullisL ul {
  display: inline-block;
  vertical-align: top;
  margin-left: 160px;
}

#ullisL ul li {
  list-style: none;
  margin-top: 20px;
  text-align: left;
  font-size: 13px;
}

@media (max-width: 768px) {
  footer {
    padding: 60px 0 30px !important;
  }

  nav {
    flex-wrap: wrap !important;
    justify-content: flex-start !important;
    margin-top: 40px;
  }

  h2 {
    font-size: 2rem !important;
  }

  .copyright {
    margin-top: 60px !important;
  }
}

/* 基础样式 */
.header {
  width: 100%;
  position: fixed;
  z-index: 999;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.header-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
}

.logo-text {
  font-size: 24px;
  font-weight: 700;
  color: #333;
  transition: color 0.3s;
}

/* 桌面导航 */
.nav-links ul {
  display: flex;
  margin: 0;
  padding: 0;
}

.nav-item {
  list-style: none;
  padding: 0 25px;
  font-size: 16px;
  color: #333;
  cursor: pointer;
  transition: color 0.3s;
}

/* 移动端菜单 */
.hamburger {
  display: none;
  cursor: pointer;
  padding: 10px;
}

.hamburger-line {
  width: 30px;
  height: 2px;
  background: #333;
  position: relative;
  transition: all 0.3s;
}

.hamburger-line::before,
.hamburger-line::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  background: inherit;
  transition: all 0.3s;
}

.hamburger-line::before {
  transform: translateY(-8px);
}

.hamburger-line::after {
  transform: translateY(8px);
}

.hamburger-line.active {
  background: transparent;
}

.hamburger-line.active::before {
  transform: rotate(45deg);
}

.hamburger-line.active::after {
  transform: rotate(-45deg);
}

.mobile-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.98);
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.mobile-nav-item {
  display: block;
  padding: 15px;
  color: #333;
  text-decoration: none;
  border-bottom: 1px solid #eee;
}

/* 响应式处理 */
@media (max-width: 992px) {
  .nav-links {
    display: none;
  }

  .hamburger {
    display: block;
  }

  .logo-text {
    font-size: 20px;
  }
}

@media (min-width: 993px) {
  .mobile-menu {
    display: none;
  }
}

/* 过渡动画 */
.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

/* 基础样式 */
.hero-container {
  position: relative;
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.spacer {
  height: 80px;
}

.content-wrapper {
  width: 100%;
  max-width: 1400px;
  margin: 80px auto 0;
  padding: 8% 5%;
  flex-grow: 1;
  box-sizing: border-box;
}

.text-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.main-title {
  font-size: 4.5rem;
  font-weight: 700;
  color: white;
  line-height: 1.1;
  margin: 0 0 1.5rem;
}

.description {
  font-size: 1.25rem;
  color: white;
  max-width: 680px;
  line-height: 1.6;
  margin: 2rem 0;
}

.contact-tip p {
  font-size: 0.875rem;
  color: rgba(255, 255, 255, 0.5);
  margin: 0 0 1rem;
}

.cta-button {
  color: white;
  border: 2px solid white;
  border-radius: 12px;
  padding: 1.25rem 3.5rem;
  font-size: 1.375rem;
  font-weight: 600;
  cursor: pointer;
  background: transparent;
  transition: all 0.3s ease;
}

.cta-button:hover {
  background: rgba(255, 255, 255, 0.1);
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .main-title {
    font-size: 3.5rem;
    margin-top: 10vh;
  }

  .content-wrapper {
    padding: 8% 5%;
  }
}

@media (max-width: 992px) {
  .main-title {
    font-size: 2.8rem;
    line-height: 1.2;
  }

  .description {
    font-size: 1.1rem;
    max-width: 500px;
  }

  .cta-button {
    padding: 1rem 2.5rem;
    font-size: 1.1rem;
  }
}

@media (max-width: 768px) {
  .spacer {
    height: 60px;
  }

  .content-wrapper {
    margin-top: 60px;
    padding: 12% 5%;
  }

  .main-title {
    font-size: 2.2rem;
    line-height: 1.3;
  }

  .description {
    font-size: 1rem;
    margin: 1.5rem 0;
  }

  .cta-button {
    width: 100%;
    max-width: 300px;
    text-align: center;
  }
}

@media (max-width: 576px) {
  .main-title {
    font-size: 1.8rem;
  }

  .description {
    font-size: 0.95rem;
  }

  .contact-tip p {
    font-size: 0.8rem;
  }

  .cta-button {
    padding: 0.8rem 1.5rem;
    font-size: 1rem;
  }
}
/* 修改后的响应式设计 */
@media (max-width: 768px) {
  .spacer {
    height: 40px; /* 减少顶部留白 */
  }

  .content-wrapper {
    margin-top: 40px;
    padding: 15% 5%;
  }

  .main-title {
    font-size: 2.6rem;  /* 从2.2rem调大 */
    line-height: 1.25;
    margin-bottom: 1.2rem;
  }

  .description {
    font-size: 1.15rem;  /* 从1rem调大 */
    line-height: 1.75;
    margin: 1.8rem 0;
  }

  .contact-tip p {
    font-size: 0.95rem;  /* 从0.8rem调大 */
    margin-bottom: 1.2rem;
  }

  .cta-button {
    font-size: 1.15rem;  /* 从1rem调大 */
    padding: 1rem 2rem;
  }
}

@media (max-width: 576px) {
  .main-title {
    font-size: 3.6rem;  /* 从1.8rem调大 */
    letter-spacing: -0.5px;
  }

  .description {
    font-size: 1.05rem;  /* 从0.95rem调大 */
    line-height: 1.7;
  }

  .contact-tip p {
    font-size: 0.9rem;  /* 保持调整后大小 */
  }

  .cta-button {
    font-size: 1.05rem;
    padding: 0.9rem 1.8rem;
  }
}

/* 新增超小手机适配 (360px以下) */
@media (max-width: 360px) {
  .main-title {
    font-size: 2rem;
    line-height: 1.3;
  }

  .description {
    font-size: 1rem;
  }
}
/* 移动端优先的响应式处理 */
router-view>div {
  padding: 15px !important;
}

@media (min-width: 768px) {
  router-view>div {
    padding: 30px 40px !important;
  }
}

@media (min-width: 1200px) {
  router-view>div {
    padding: 40px 80px !important;
  }
}

/* 超宽屏保护 */
@media (min-width: 1600px) {
  router-view>div {
    max-width: 1600px;
  }
}
</style>
